import { PropsWithChildren } from "react";
import { Separator } from "@fluentui/react/lib/Separator";
import { Text } from "@fluentui/react/lib/Text";

import { CustomPanel, CustomPanelSizeType } from "Components/Generic/CustomPanel";
import { WithTranslator } from "Components/Generic/Translator";
import { isFalse } from "Utils/Boolean";
import { IListNotExportableDialogProps } from "./IListNotExportableDialogProps";
import { MissingFieldsList } from "./MissingFieldsList";
import { useListNotExportableStyles } from "./UseListNotExportableStyles";

export const ListNotExportableDialog = WithTranslator(
  (props: PropsWithChildren<IListNotExportableDialogProps>): JSX.Element => {
    const {
      hidden, missingFieldList, onConfirm, onDismiss, translator
    } = props;
    const styles = useListNotExportableStyles();
    const allowExport = onConfirm != null;

    return (
      <CustomPanel
        customPanelSize={CustomPanelSizeType.small}
        isOpen={isFalse(hidden, true)}
        headerTitle={translator.get(
          `export.missingrequiredfields.title`,
          `Selected projects are missing required fields!`
        )}
        onDismiss={onDismiss}
        isBlocking
        isLightDismiss
        onButtonClick={onConfirm}
        buttonText={translator.get(`export.missingrequiredfields.yes`, `Export`)}
        buttonIcon="Export"
      >
        <div className={styles.root}>
          <div className={styles.description}>
            <Text>
              {translator.get(
                `export.missingrequiredfields.text${allowExport ? `` : `2`}`,
                allowExport
                  ? `When you click on "Export", only complete projects are exported. The incomplete projects will be skipped. The following projects are incomplete:`
                  : `You cannot export because mandatory fields are missing in each selected project. Please correct the values and start the export again. The following projects are incomplete:`
              )}
            </Text>
          </div>
          <div className={styles.separator}>
            <Separator />
          </div>
          <div className={styles.list} data-is-scrollable>
            <MissingFieldsList missingFields={missingFieldList} />
          </div>
        </div>
      </CustomPanel>
    );
  }
);
